<template>
  <div class="fill-height">
    <AppToolbar :prev-route="{ name: 'home' }"></AppToolbar>
    <v-row v-if="isLoading || uploadingImage" class="fill-height" align="center" justify="center">
      <v-progress-circular indeterminate size="50" color="primary"></v-progress-circular>
    </v-row>
    <template v-else-if="item">
      <div class="blue text-center px-4 pb-4 white--text">
        <croppa
          v-model="myCroppa"
          class="mb-2"
          :initial-image="item.image ? item.image.contentUrl + '?x-request=html' : null"
          :width="150"
          :height="150"
          :quality="2"
          :accept="'image/*'"
          :placeholder="$t('message.choose_an_image')"
          :placeholder-font-size="14"
          @file-choose="imageChanged = true"
          @image-remove="imageChanged = true"
        ></croppa>
        <div class="headline">{{ item.firstName }} {{ item.lastName }}</div>
      </div>

      <v-container>
        <v-row justify="center">
          <v-col cols="12" style="max-width: 640px">
            <UserForm ref="updateForm" :values="item" :errors="violations" />

            <v-row v-if="$refs.updateForm" justify="end">
              <div>
                <v-btn class="ma-2" color="grey" text :to="{ name: 'home' }">{{ $t('message.cancel') }}</v-btn>
                <v-btn class="ma-2" :disabled="!$refs.updateForm.valid" color="primary" @click="onSendForm">
                  {{ $t('message.save') }}
                </v-btn>
              </div>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </template>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { mapFields } from 'vuex-map-fields'
import UserForm from '@/components/User/Form.vue'
import AppToolbar from '@/components/AppToolbar'

export default {
  name: 'UserEdit',

  components: {
    AppToolbar,
    UserForm
  },

  data() {
    return {
      flatBar: true,
      myCroppa: {},
      imageChanged: false,
      uploadingImage: false
    }
  },

  computed: {
    ...mapFields('user', {
      deleteLoading: 'isLoading',
      isLoading: 'isLoading',
      error: 'error',
      updated: 'updated',
      violations: 'violations'
    }),
    ...mapGetters('user', ['find']),

    item() {
      return this.find(`/users/${this.$usailSecurity.getUser().sub}`)
    }
  },

  watch: {
    updated: function(updated) {
      if (!updated) {
        return
      }

      this.$router.push({ name: 'home' })
    }
  },

  created() {
    this.retrieve('/users/' + this.$usailSecurity.getUser().sub)
    window.addEventListener('scroll', this.handleScroll)
  },

  destroyed: function() {
    window.removeEventListener('scroll', this.handleScroll)
  },

  methods: {
    ...mapActions('user', {
      deleteItem: 'del',
      retrieve: 'load',
      update: 'update'
    }),

    handleScroll(event) {
      this.flatBar = !(event.target.body.scrollTop > 1 || event.target.documentElement.scrollTop > 1)
    },

    onSendForm() {
      const updateForm = this.$refs.updateForm

      if (updateForm.$refs.form.validate()) {
        let cleanItem = { ...updateForm.item }

        cleanItem.roleInVessels.forEach(roleInVessel => {
          if ('string' !== typeof roleInVessel.vessel) {
            roleInVessel.vessel = roleInVessel.vessel['@id']
          }

          if ('string' !== typeof roleInVessel.vesselRole) {
            roleInVessel.vesselRole = roleInVessel.vesselRole['@id']
          }
        })

        cleanItem.roleInOrganizations.forEach(roleInOrganization => {
          if ('string' !== typeof roleInOrganization.organization) {
            roleInOrganization.organization = roleInOrganization.organization['@id']
          }

          if ('string' !== typeof roleInOrganization.organizationRole) {
            roleInOrganization.organizationRole = roleInOrganization.organizationRole['@id']
          }
        })

        this.myCroppa.generateBlob(
          blob => {
            if (this.imageChanged) {
              if (blob) {
                let formData = new FormData()
                formData.append('file', blob)

                this.uploadingImage = true

                return this.$api
                  .fetch('/media_objects', {
                    method: 'POST',
                    body: formData
                  })
                  .then(response => {
                    this.uploadingImage = false
                    return response.json()
                  })
                  .then(data => {
                    cleanItem.image = data
                    this.update(cleanItem)
                  })
                  .catch(e => {
                    // eslint-disable-next-line no-console
                    console.log(e)
                  })
              } else {
                cleanItem.image = null
                this.update(cleanItem)
              }
            } else {
              this.update(cleanItem)
            }
          },
          null,
          0.8
        )
      }
    }
  }
}
</script>
